import { render, staticRenderFns } from "./about.vue?vue&type=template&id=2d11d9a2&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=2d11d9a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d11d9a2",
  null
  
)

export default component.exports